import {
    GET_CRM_DATA,
    UPDATE_CRM_DATA
} from '../ActionTypes/ActionTypes';


const initialState = {
    crmData: {}
};
function CRMReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {

        case GET_CRM_DATA:
            return {
                ...state,
                crmData: payload,
            };

        case UPDATE_CRM_DATA:
            return Object.assign({}, state, {                
                crmData: action.payload,
            });
        
        default:
            return state;
    }
};

export default CRMReducer;